import { useEffect, RefObject } from 'react';

import { useApplicationContext } from 'shared/containers/ApplicationContext';

export const useRutubePlayer = (iframeRef: RefObject<HTMLIFrameElement>) => {
  const { logger, telemetry } = useApplicationContext();

  useEffect(() => {
    telemetry.increment('RutubePlayer.init');

    const iframe = iframeRef.current;

    if (!iframe) {
      return;
    }

    window.addEventListener('message', function (event) {
      const message = JSON.parse(event.data);

      switch (message.type) {
        case 'player:init':
          telemetry.increment('RutubePlayer.inited');
          break;

        case 'player:ready':
          telemetry.increment('RutubePlayer.ready');
          break;

        case 'player:error':
          logger.error('Rutube player error', {
            error: JSON.stringify(message.data),
          });
          break;
      }
    });
  }, [iframeRef, logger, telemetry]);
};
